import React, { useState, useEffect, useMemo } from 'react'
import './updateInfo.css'
import { useParams, useNavigate } from 'react-router'
import { useLocation } from 'react-router'
import axios from 'axios'
const UpdateInfoClaimManual = () => {
  const [activeTab, setActiveTab] = useState('partEntries')
  const [errors, setErrors] = useState({})
  const [showPopup, setShowPopup] = useState(false)
  const [uploading, setUploading] = useState(false)
  const [popupMessage, setPopupMessage] = useState('')
  const { claimNumber } = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const allClaims = useMemo(() => {
    return JSON.parse(localStorage.getItem('claimsData')) || []
  }, [])

  const claimFromState = useMemo(() => {
    return allClaims.find(claim => claim.claimNumber === claimNumber)
  }, [allClaims, claimNumber])
  //   const claimFromState = location.state?.claimFromState;
  console.log('14', claimFromState)
  const [surveyorId, setSurveyorId] = useState(null)
  const [data, setData] = useState(null)

  // useEffect(() => {
  //   if (claimNumber) {
  //     axios
  //       .post(`/server/get-invoice-data/${claimNumber}`)
  //       .then(response => {
  //         console.log('32', response.data)
  //         setData(response.data)
  //       })
  //       .catch(error => console.error('Axios error:', error))
  //   }
  // }, [claimNumber])
  const [progressData, setProgressData] = useState({})

  useEffect(() => {
    const fetchProgress = async () => {
      if (claimNumber) {
        try {
          const res = await axios.post(
            `/process_data/claim_progress/${claimNumber}`
          )
          setProgressData(res.data)
          console.log('progress-32', res.data)
        } catch (err) {
          console.error('Error fetching claim progress:', err)
        }
      }
    }
    fetchProgress()
  }, [claimNumber])
  // useEffect(() => {
  //   if (claimNumber) {

  //       if (progressData?.pre_invoice=='1') {
  //       console.log("59-pre-invoice-extract-update-info");

  //       axios
  //         .post(`/server/get-pre-invoice-data/${claimNumber}`)
  //         .then(response => {
  //           console.log('pre-invoice update info data', response.data)

  //           setData(response.data)
  //         })
  //         .catch(error => console.error('Axios error:', error))
  //       return
  //     } else {
  //       // console.log("71-invoice-extract-update-info")
  //       axios
  //         .post(`/server/get-invoice-data/${claimNumber}`)
  //         .then(response => {
  //           console.log('invoice data update info', response.data)

  //           setData(response.data)
  //         })
  //         .catch(error => console.error('Axios error:', error))
  //     }
  //   }
  // }, [claimNumber])
  useEffect(() => {
    if (claimNumber && progressData) {
      if (progressData?.pre_invoice == '1') {
        console.log('59-pre-invoice-extract-update-info')
        axios
          .post(`/server/get-pre-invoice-data/${claimNumber}`)
          .then(response => {
            console.log('pre-invoice update info data', response.data)
            setData(response.data)
          })
          .catch(error => console.error('Axios error:', error))
        return
      } else {
        axios
          .post(`/server/get-invoice-data/${claimNumber}`)
          .then(response => {
            console.log('invoice data update info', response.data)
            setData(response.data)
          })
          .catch(error => console.error('Axios error:', error))
      }
    }
  }, [claimNumber, progressData]) //  Add progressData here

  useEffect(() => {
    const fetchSurveyorId = async () => {
      try {
        const response = await fetch('/process_data/get_surveyor_id', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ claimNumber: claimNumber })
        })

        const data = await response.json()
        if (data?.surveyor_id) {
          setSurveyorId(data.surveyor_id)
          console.log('Surveyor ID:', data.surveyor_id)
        }
      } catch (error) {
        console.error('Failed to fetch surveyor ID:', error)
      }
    }

    if (claimNumber) {
      fetchSurveyorId()
    }
  }, [claimNumber])

  const handleTabClick = tab => {
    // Check if current tab fields are all filled before allowing navigation
    const currentTabFields = getTabFields(activeTab)
    const isCurrentTabValid = true
    // const isCurrentTabValid = validateTabFields(currentTabFields);

    if (isCurrentTabValid || tab === activeTab) {
      setActiveTab(tab)
      // Clear errors when changing tabs
      setErrors({})
      setShowPopup(false)
    } else {
      // Show popup instead of field-level errors
      setPopupMessage('Please fill all required fields before proceeding.')
      setShowPopup(true)

      // Set errors for empty fields (to highlight them)
      const newErrors = {}
      currentTabFields.forEach(field => {
        if (!formData[field] || formData[field].trim() === '') {
          newErrors[field] = 'This field is required'
        }
      })
      setErrors(newErrors)
    }
  }

  // Get field names for each tab
  const getTabFields = tab => {
    switch (tab) {
      case 'insurance':
        return [
          'policyNumber',
          'insurancePeriod',
          'idv',
          'claimNumber',
          'endorsement',
          'insuranceCompany',
          'insured',
          'hpa',
          'appointedBy'
        ]
      case 'vehicle':
        return [
          'VehicleRegistrationNumber',
          'RegisteredOwner',
          'OwnerSerialNoTransferDate',
          'DateofRegistration',
          'ChassisNumber',
          'EngineNumber',
          'Variant',
          'Color',
          'CubicCapacity',
          'FuelUsed',
          'OdoMeterReading',
          'PUCNumber',
          'ValidUpto'
        ]
      case 'driver':
        return [
          'NameofDriver',
          'DateofBirth',
          'DrivingLicenseNo',
          'DateofIssue',
          'ValidFrom',
          'ValidUptoNTV',
          'ValidUptoTV',
          'IssuingAuthority',
          'TypeofLicense',
          'BadgeNumber'
        ]
      case 'accident':
        return [
          'dateOfAccident',
          'timeOfAccident',
          'placeOfAccident',
          'placeOfSurvey',
          'dateOfAllotment',
          'dateTimeOfSurvey',
          'dateOfSpotSurvey',
          'causeAndNature',
          'policeAction',
          'detailsOfLoad',
          'thirdPartyLoss',
          'particularsOfLoss'
        ]
      case 'partEntries':
        return [
          'job',
          'material',
          'description',
          'hsn',
          'qty',
          'rate',
          'taxPercent',
          'depPercent',
          'rrCharges',
          'repairCharges',
          'paintingCharges',
          'labourCharges'
        ]

      default:
        return []
    }
  }

  // Validate if all fields in a tab are filled
  const validateTabFields = fields => {
    return fields.every(field => {
      const value = formData[field] || claimFromState?.[field]
      return value && value.trim() !== ''
    })
  }

  const defaultParts = [
    {
      job: 'Replace',
      material: 'Plastic',
      description: 'GARNISH ASSY QTR SIDE LH',
      hsn: '87089900',
      qty: '1',
      rate: '275',
      taxPercent: '28',
      depPercent: '0',
      rrCharges: '0.0',
      repairCharges: '0.0',
      paintingCharges: '0.0',
      labourCharges: '0.0'
    }
  ]

  const getInitialFormData = data => ({
    claimNumber: data?.claimNumber || claimNumber,
    ticket_number: data?.ticket_number || '',
    payment_to: data?.payment_to || '',
    workshop_name: data?.workshop_name || '',
    workshop_gst_number: data?.workshop_gst_number || '',
    vehicle_age: data?.vehicle_age || '',
    invoice_number: data?.invoice_number || '',
    invoice_date_time: data?.invoice_date_time || '',
    parts:
      Array.isArray(data?.parts) && data.parts.length > 0
        ? data.parts
        : defaultParts,
    labour_details:
      Array.isArray(data?.labour_details) && data.labour_details.length > 0
        ? data.labour_details
        : '',

    final_calculation:
      data?.final_calculation &&
      typeof data.final_calculation === 'object' &&
      Object.keys(data.final_calculation).length > 0
        ? data.final_calculation
        : '',
    workshop_details:
      data?.workshop_details &&
      typeof data.workshop_details === 'object' &&
      Object.keys(data.workshop_details).length > 0
        ? data.workshop_details
        : ''
  })

  const [formData, setFormData] = useState(getInitialFormData({})) // start with default values
  useEffect(() => {
    if (data) {
      setFormData(getInitialFormData(data))
    }
  }, [data])

  const handleContinue = nextTab => {
    const currentTabFields = getTabFields(activeTab)
    const isCurrentTabValid = validateTabFields(currentTabFields)

    if (isCurrentTabValid) {
      setActiveTab(nextTab)
      // Clear errors when changing tabs
      setErrors({})
      setShowPopup(false)
    } else {
      // Show popup instead of just field-level errors
      setPopupMessage('Please fill all required fields before proceeding.')
      setShowPopup(true)

      // Set errors for empty fields (to highlight them)
      // const newErrors = {};
      // currentTabFields.forEach(field => {
      //   if (!formData[field] || formData[field].trim() === "") {
      //     newErrors[field] = "This field is required";
      //   }
      // });
      // setErrors(newErrors);
      //   const newErrors = {}
      //   currentTabFields.forEach(field => {
      //     const value = formData[field] || claimFromState?.[field]
      //     if (!value || value.trim() === '') {
      //       newErrors[field] = 'This field is required'
      //     }
      //   })
      //   setErrors(newErrors)
    }
  }
  useEffect(() => {
    if (claimFromState) {
      setFormData(prev => ({
        ...prev,
        claimNumber: claimFromState.claimNumber || prev.claimNumber,
        policyNumber: claimFromState.policyNumber || prev.policyNumber,
        VehicleRegistrationNumber:
          claimFromState.vehicle || prev.VehicleRegistrationNumber,
        Variant: claimFromState.model || prev.Variant,
        Make: claimFromState.make
        // Add more mappings as needed
      }))
    }
  }, [claimFromState])

  const saveFormDataToBackend = async () => {
    // Check if all tabs are filled properly
    const insuranceTabFields = getTabFields('insurance')
    const vehicleTabFields = getTabFields('vehicle')
    const driverTabFields = getTabFields('driver')
    const accidentTabFields = getTabFields('accident')
    const partEntriesTabFields = getTabFields('partEntries')

    // const isInsuranceTabValid = validateTabFields(insuranceTabFields);
    // const isVehicleTabValid = validateTabFields(vehicleTabFields);
    // const isDriverTabValid = validateTabFields(driverTabFields);
    // const isAccidentTabValid = validateTabFields(accidentTabFields);
    const ispartEntriesTabValid = true

    // if (ispartEntriesTabValid) {
    if (ispartEntriesTabValid) {
      setUploading(true) // Show "Uploading data..." pop-up
      try {
        let response = ''
        if (progressData?.pre_invoice == '1') {
          response = await fetch('/server/upload-pre-invoice-info-data', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
        } else {
          response = await fetch('/server/upload-invoice-info-data', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
        }

        if (response.ok) {
          const data = await response.json()
          console.log(`233`, data)
          // Update work_app_update to TRUE in claim_progress
          // await fetch('/process_data/update_work_app_update', {
          //   method: 'POST',
          //   headers: {
          //     'Content-Type': 'application/json'
          //   },
          //   body: JSON.stringify({ claimNumber: formData.claimNumber })
          // })
          const statusUploadd = await axios.post(
            '/process_data/update_invoice_report',
            {
              claimNumber
            }
          )
          setPopupMessage(`Claim data has been successfully uploaded! `)

          setTimeout(() => {
            navigate(`/final-claim-report/${claimNumber}`)
          }, 3000)
          setActiveTab('insurance') // Reset to the first tab
          setErrors({})
        } else {
          const errorData = await response.json()
          setPopupMessage(
            `Failed to upload claim data. ${
              errorData.error || 'Please try again.'
            }`
          )
          console.error('Backend Upload Error:', errorData)
        }
      } catch (error) {
        setPopupMessage('Failed to connect to the server.')
        console.error('Frontend Error:', error)
      } finally {
        setUploading(false) // Hide "Uploading data..." pop-up
        setShowPopup(true) // Show success/error message pop-up
      }
    } else {
      setPopupMessage(
        'Please complete all required fields in all tabs before finishing.'
      )
      setShowPopup(true)

      // if (!isInsuranceTabValid) setActiveTab("insurance");
      // else if (!isVehicleTabValid) setActiveTab("vehicle");
      // else if (!isDriverTabValid) setActiveTab("driver");
      // else if (!isAccidentTabValid) setActiveTab("accident");
    }
  }

  // Close the popup and focus on the first empty field
  const closePopup = () => {
    setShowPopup(false)

    // Find the first empty field and focus on it
    const currentTabFields = getTabFields(activeTab)
    for (const field of currentTabFields) {
      if (!formData[field] || formData[field].trim() === '') {
        const element = document.querySelector(`[name="${field}"]`)
        if (element) {
          element.focus()
          break
        }
      }
    }
  }

  const initialRow = {
    job: '',
    material: '',
    description: '',
    hsn: '',
    qty: 0,
    rate: 0,
    taxPercent: 0,
    depPercent: 0,
    rrCharges: 0.0,
    repairCharges: 0.0,
    paintingCharges: 0.0,
    labourCharges: 0.0
  }

  const [rows, setRows] = useState([initialRow])

  useEffect(() => {
    const parts =
      Array.isArray(data?.parts) && data.parts.length > 0
        ? data.parts
        : [initialRow]
    const formattedParts = parts.map(part => ({
      ...initialRow,
      ...part,
      qty: Number(part.qty) || 0,
      rate: Number(part.rate) || 0,
      taxPercent: Number(part.taxPercent) || 0,
      depPercent: Number(part.depPercent) || 0,
      rrCharges: Number(part.rrCharges) || 0.0,
      repairCharges: Number(part.repairCharges) || 0.0,
      paintingCharges: Number(part.paintingCharges) || 0.0,
      labourCharges: Number(part.labourCharges) || 0.0
    }))
    setRows(formattedParts)
    console.log('523', rows)
  }, [data])

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      parts: rows
    }))
  }, [rows])
  const handleChangeParts = (index, field, value) => {
    // setFormData({ ...formData, [field]: value });
    console.log('336', formData)

    const updated = [...rows]
    updated[index][field] = [
      'qty',
      'rate',
      'taxPercent',
      'depPercent',
      'rrCharges',
      'repairCharges',
      'paintingCharges',
      'labourCharges'
    ].includes(field)
      ? parseFloat(value) || 0
      : value
    setRows(updated)
  }

  const handleChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })

    // Clear error for this field when user starts typing
    if (errors[name]) {
      setErrors({ ...errors, [name]: '' })
    }
  }

  const addRow = () => setRows([...rows, { ...initialRow }])
  const deleteRow = index => {
    const updated = [...rows]
    updated.splice(index, 1)
    setRows(updated)
  }

  const calculateRow = row => {
    const taxable = row.rate * row.qty
    const taxAmount = (taxable * row.taxPercent) / 100
    const total = taxable + taxAmount
    const depAmount = (taxable * row.depPercent) / 100
    return { taxable, taxAmount, total, depAmount }
  }

  const subtotal = rows.reduce(
    (acc, row) => {
      const { taxable, taxAmount, total, depAmount } = calculateRow(row)
      acc.taxable += taxable
      acc.taxAmount += taxAmount
      acc.total += total
      acc.depAmount += depAmount
      return acc
    },
    { taxable: 0, taxAmount: 0, total: 0, depAmount: 0 }
  )
  return (
    <div className='update-info-container'>
      <h2 className='update-info-title'>Claim Details</h2>

      {showPopup && (
        <div className='popup-overlay'>
          <div className='popup-container'>
            <div className='popup-header'>
              <h3>
                {popupMessage.startsWith('Failed')
                  ? 'Error'
                  : popupMessage.startsWith('Please')
                  ? 'Required Fields'
                  : 'Success'}
              </h3>
              <button className='close-btn' onClick={closePopup}>
                ×
              </button>
            </div>
            <div className='popup-content-info'>
              <p>{popupMessage}</p>
            </div>
            <div className='popup-footer'>
              <button className='popup-btn' onClick={closePopup}>
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Uploading Overlay */}
      {uploading && (
        <div className='popup-overlay'>
          <div className='popup-container'>
            <div className='popup-content-info'>
              <p>Uploading data...</p>
            </div>
          </div>
        </div>
      )}
      <div className='update-info-claim-header'>
        <div className='update-info-claim-field'>
          <label>Surveyors Reference No.</label>
          <input type='text' value={surveyorId || ''} readOnly />
        </div>
        <div className='update-info-claim-field'>
          <label>Claim Intimation Date</label>
          <input type='text' value={claimFromState?.date || ''} readOnly />
        </div>
        <div className='update-info-claim-field'>
          <label>Claim Number</label>
          <input type='text' value={claimNumber || ''} readOnly />
        </div>
      </div>

      {/* Tabs */}
      <div className='update-info-tabs'>
        <button
          className={activeTab === 'insurance' ? 'active' : ''}
          // onClick={() => handleTabClick("insurance")}
        >
          Insurance Details
        </button>
        <button
          className={activeTab === 'vehicle' ? 'active' : ''}
          // onClick={() => handleTabClick("vehicle")}
        >
          Vehicle Details
        </button>
        <button
          className={activeTab === 'driver' ? 'active' : ''}
          // onClick={() => handleTabClick("driver")}
        >
          Driver Details
        </button>
        <button
          className={activeTab === 'accident' ? 'active' : ''}
          // onClick={() => handleTabClick("accident")}
        >
          Accident & Survey
        </button>
        <button
          className={activeTab === 'partEntries' ? 'active' : ''}
          onClick={() => handleTabClick('partEntries')}
        >
          Part Entries
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'insurance' && (
        <div className='vehicle-details-container'>
          <div className='update-info-tab-content'>
            <div className='update-info-form-group'>
              <label>Policy/Cover Note No.</label>
              <input
                type='text'
                name='policyNumber'
                value={claimFromState?.policyNumber || formData.policyNumber}
                onChange={handleChange}
                className={errors.policyNumber ? 'error-input' : ''}
              />
            </div>

            <div className='update-info-form-group'>
              <label>Insurance Period From</label>
              <input
                type='date'
                name='insurancePeriod'
                value={formData.insurancePeriod}
                onChange={handleChange}
                className={errors.insurancePeriod ? 'error-input' : ''}
              />
            </div>
            <div className='update-info-form-group'>
              <label>IDV</label>
              <input
                type='text'
                name='idv'
                value={formData.idv}
                onChange={handleChange}
                className={errors.idv ? 'error-input' : ''}
              />
            </div>
            <div className='update-info-form-group'>
              <label>Claim No.</label>
              <input
                type='text'
                name='claimNumber'
                value={claimFromState?.claimNumber || claimNumber}
                onChange={handleChange}
                className={errors.claimNumber ? 'error-input' : ''}
              />
            </div>
            <div className='update-info-form-group'>
              <label>Endorsement</label>
              <input
                type='text'
                name='endorsement'
                value={formData.endorsement}
                onChange={handleChange}
                className={errors.endorsement ? 'error-input' : ''}
              />
            </div>
            <div className='update-info-form-group'>
              <label>Insurance Company</label>
              <input
                type='text'
                name='insuranceCompany'
                value={formData.insuranceCompany}
                onChange={handleChange}
                className={errors.insuranceCompany ? 'error-input' : ''}
              />
            </div>
            <div className='update-info-form-group'>
              <label>Insured</label>
              <input
                type='text'
                name='insured'
                value={formData.insured}
                onChange={handleChange}
                className={errors.insured ? 'error-input' : ''}
              />
            </div>
            <div className='update-info-form-group'>
              <label>HPA</label>
              <input
                type='text'
                name='hpa'
                value={formData.hpa}
                onChange={handleChange}
                className={errors.hpa ? 'error-input' : ''}
              />
            </div>
            <div className='update-info-form-group'>
              <label>Appointed By</label>
              <input
                type='text'
                name='appointedBy'
                value={formData.appointedBy}
                onChange={handleChange}
                className={errors.appointedBy ? 'error-input' : ''}
              />
            </div>
          </div>
          <div className='update-info-button-container'>
            <button
              className='update-info-continue-btn'
              onClick={() => handleContinue('vehicle')}
            >
              Continue →
            </button>
          </div>
        </div>
      )}

      {activeTab === 'vehicle' && (
        <div className='vehicle-details-container'>
          <div className='vehicle-details-grid'>
            <div className='form-group'>
              <label>Vehicle Registration Number</label>
              <input
                type='text'
                name='VehicleRegistrationNumber'
                value={
                  claimFromState?.vehicle || formData.VehicleRegistrationNumber
                }
                onChange={handleChange}
                className={
                  errors.VehicleRegistrationNumber ? 'error-input' : ''
                }
              />
            </div>
            <div className='form-group'>
              <label>Registered Owner</label>
              <input
                type='text'
                name='RegisteredOwner'
                value={formData.RegisteredOwner}
                onChange={handleChange}
                className={errors.RegisteredOwner ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Owner Serial No/Transfer Date</label>
              <input
                type='text'
                name='OwnerSerialNoTransferDate'
                value={formData.OwnerSerialNoTransferDate}
                onChange={handleChange}
                className={
                  errors.OwnerSerialNoTransferDate ? 'error-input' : ''
                }
              />
            </div>
            <div className='form-group'>
              <label>Date of Registration</label>
              <input
                type='date'
                name='DateofRegistration'
                value={formData.DateofRegistration}
                onChange={handleChange}
                className={errors.DateofRegistration ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Chassis Number / VIN</label>
              <input
                type='text'
                name='ChassisNumber'
                value={formData.ChassisNumber}
                onChange={handleChange}
                className={errors.ChassisNumber ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Chassis No. Physically checked</label>
              <select>
                <option>Yes</option>
                <option>No</option>
              </select>
            </div>
            <div className='form-group'>
              <label>Make</label>
              {/* <select>
                <option>Hyundai</option>
              </select> */}
              <input
                type='text'
                name='Make'
                value={claimFromState?.make || ''}
                onChange={handleChange}
                className={errors.Make ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Model</label>
              <input
                type='text'
                name='Variant'
                value={claimFromState?.model}
                onChange={handleChange}
                className={errors.Variant ? 'error-input' : ''}
              />
            </div>{' '}
            <div className='form-group'>
              <label>Engine Number</label>
              <input
                type='text'
                name='EngineNumber'
                value={formData.EngineNumber}
                onChange={handleChange}
                className={errors.EngineNumber ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Color</label>
              <input
                type='text'
                name='Color'
                value={formData.Color}
                onChange={handleChange}
                className={errors.Color ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Type of Body/Vehicle Class</label>
              <select>
                <option>SUV Car</option>
              </select>
            </div>
            <div className='form-group'>
              <label>Pre-Accident Condition</label>
              <select>
                <option>Road worthy</option>
              </select>
            </div>
            <div className='form-group'>
              <label>Seating Capacity</label>
              <select>
                <option>4 Nos</option>
              </select>
            </div>
            <div className='form-group'>
              <label>Cubic Capacity</label>
              <input
                type='text'
                name='CubicCapacity'
                value={formData.CubicCapacity}
                onChange={handleChange}
                className={errors.CubicCapacity ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Fuel Used</label>
              <input
                type='text'
                name='FuelUsed'
                value={formData.FuelUsed}
                onChange={handleChange}
                className={errors.FuelUsed ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Tax Particulars</label>
              <select>
                <option>Life Time</option>
              </select>
            </div>
            <div className='form-group'>
              <label>Odo Meter Reading</label>
              <input
                type='text'
                name='OdoMeterReading'
                value={formData.OdoMeterReading}
                onChange={handleChange}
                className={errors.OdoMeterReading ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>PUC Number</label>
              <input
                type='text'
                name='PUCNumber'
                value={formData.PUCNumber}
                onChange={handleChange}
                className={errors.PUCNumber ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Valid Upto</label>
              <input
                type='text'
                name='ValidUpto'
                value={formData.ValidUpto}
                onChange={handleChange}
                className={errors.ValidUpto ? 'error-input' : ''}
              />
            </div>
          </div>
          <div className='update-info-button-container'>
            <button
              className='update-info-continue-btn'
              onClick={() => handleContinue('driver')}
            >
              Continue →
            </button>
          </div>
        </div>
      )}

      {activeTab === 'driver' && (
        <div className='vehicle-details-container'>
          <div className='vehicle-details-grid'>
            <div className='form-group'>
              <label>Name of Driver</label>
              <input
                type='text'
                name='NameofDriver'
                value={formData.NameofDriver}
                onChange={handleChange}
                className={errors.NameofDriver ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Date of Birth</label>
              <input
                type='date'
                name='DateofBirth'
                value={formData.DateofBirth}
                onChange={handleChange}
                className={errors.DateofBirth ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Driving License No</label>
              <input
                type='text'
                name='DrivingLicenseNo'
                value={formData.DrivingLicenseNo}
                onChange={handleChange}
                className={errors.DrivingLicenseNo ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Date of Issue</label>
              <input
                type='date'
                name='DateofIssue'
                value={formData.DateofIssue}
                onChange={handleChange}
                className={errors.DateofIssue ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Valid From</label>
              <input
                type='date'
                name='ValidFrom'
                value={formData.ValidFrom}
                onChange={handleChange}
                className={errors.ValidFrom ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Valid Upto (NTV)</label>
              <input
                type='date'
                name='ValidUptoNTV'
                value={formData.ValidUptoNTV}
                onChange={handleChange}
                className={errors.ValidUptoNTV ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Valid Upto (TV)</label>
              <input
                type='date'
                name='ValidUptoTV'
                value={formData.ValidUptoTV}
                onChange={handleChange}
                className={errors.ValidUptoTV ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Issuing Authority</label>
              <input
                type='text'
                name='IssuingAuthority'
                value={formData.IssuingAuthority}
                onChange={handleChange}
                className={errors.IssuingAuthority ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Type of License</label>
              <input
                type='text'
                name='TypeofLicense'
                value={formData.TypeofLicense}
                onChange={handleChange}
                className={errors.TypeofLicense ? 'error-input' : ''}
              />
            </div>
            <div className='form-group'>
              <label>Badge Number</label>
              <input
                type='text'
                name='BadgeNumber'
                value={formData.BadgeNumber}
                onChange={handleChange}
                className={errors.BadgeNumber ? 'error-input' : ''}
              />
            </div>
          </div>
          <div className='update-info-button-container'>
            <button
              className='update-info-continue-btn'
              onClick={() => handleContinue('accident')}
            >
              Continue →
            </button>
          </div>
        </div>
      )}

      {activeTab === 'accident' && (
        <div className='vehicle-details-container'>
          <div className='accident-survey-grid'>
            {/* First line - Date, Time, Place info */}
            <div className='accident-survey-row'>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label>Accident Date</label>
                  <input
                    type='date'
                    name='dateOfAccident'
                    value={formData.dateOfAccident}
                    onChange={handleChange}
                    className={errors.dateOfAccident ? 'error-input' : ''}
                  />
                </div>
              </div>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label> Accident Time</label>
                  <input
                    type='text'
                    name='timeOfAccident'
                    value={formData.timeOfAccident}
                    onChange={handleChange}
                    className={errors.timeOfAccident ? 'error-input' : ''}
                  />
                </div>
              </div>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label>Place of Accident</label>
                  <input
                    type='text'
                    name='placeOfAccident'
                    value={formData.placeOfAccident}
                    onChange={handleChange}
                    className={errors.placeOfAccident ? 'error-input' : ''}
                  />
                </div>
              </div>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label>Place of Survey</label>
                  <input
                    type='text'
                    name='placeOfSurvey'
                    value={formData.placeOfSurvey}
                    onChange={handleChange}
                    className={errors.placeOfSurvey ? 'error-input' : ''}
                  />
                </div>
              </div>
            </div>

            {/* Second line - Survey Dates */}
            <div className='accident-survey-row'>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label>Date of Allotment of Survey</label>
                  <input
                    type='date'
                    name='dateOfAllotment'
                    value={formData.dateOfAllotment}
                    onChange={handleChange}
                    className={errors.dateOfAllotment ? 'error-input' : ''}
                  />
                </div>
              </div>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label>Date and Time of Survey</label>
                  <input
                    type='date'
                    name='dateTimeOfSurvey'
                    value={formData.dateTimeOfSurvey}
                    onChange={handleChange}
                    className={errors.dateTimeOfSurvey ? 'error-input' : ''}
                  />
                </div>
              </div>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label>Date of Receipt of Spot Survey</label>
                  <input
                    type='date'
                    name='dateOfSpotSurvey'
                    value={formData.dateOfSpotSurvey}
                    onChange={handleChange}
                    className={errors.dateOfSpotSurvey ? 'error-input' : ''}
                  />
                </div>
              </div>
            </div>

            {/* Third line - Cause and Nature of Accident */}
            <div className='accident-survey-row full-width'>
              <div className='form-group'>
                <label>Cause and Nature of Accident</label>
                <textarea
                  name='causeAndNature'
                  value={formData.causeAndNature}
                  onChange={handleChange}
                  className={errors.causeAndNature ? 'error-input' : ''}
                  rows='3'
                />
              </div>
            </div>

            {/* Fourth line - Police, Load, Third Party */}
            <div className='accident-survey-row'>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label>Police Action</label>
                  <input
                    type='text'
                    name='policeAction'
                    value={formData.policeAction}
                    onChange={handleChange}
                    className={errors.policeAction ? 'error-input' : ''}
                  />
                </div>
              </div>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label>Details of Load/Passenger</label>
                  <input
                    type='text'
                    name='detailsOfLoad'
                    value={formData.detailsOfLoad}
                    onChange={handleChange}
                    className={errors.detailsOfLoad ? 'error-input' : ''}
                  />
                </div>
              </div>
              <div className='accident-survey-column'>
                <div className='form-group'>
                  <label>Third Party Loss/Injuries</label>
                  <input
                    type='text'
                    name='thirdPartyLoss'
                    value={formData.thirdPartyLoss}
                    onChange={handleChange}
                    className={errors.thirdPartyLoss ? 'error-input' : ''}
                  />
                </div>
              </div>
            </div>

            {/* Fifth line - Particulars of Loss/Damages */}
            <div className='accident-survey-row full-width'>
              <div className='form-group'>
                <label>Particulars of Loss/Damages</label>
                <textarea
                  name='particularsOfLoss'
                  value={formData.particularsOfLoss}
                  onChange={handleChange}
                  className={errors.particularsOfLoss ? 'error-input' : ''}
                  rows='3'
                />
              </div>
            </div>
          </div>

          {/* <div className="update-info-button-container">
            <button
              className="update-info-submit-btn"
              onClick={saveFormDataToBackend}
              disabled={uploading}
            >
              {uploading ? "Uploading..." : "Finish →"}
            </button>
          </div> */}
          <div className='update-info-button-container'>
            <button
              className='update-info-continue-btn'
              onClick={() => handleContinue('partEntries')}
            >
              Continue →
            </button>
          </div>
        </div>
      )}

      {activeTab === 'partEntries' && (
        <div className='claim-container-part'>
          <table className='claim-table'>
            <thead>
              <tr>
                <th>SN</th>
                <th>JOB</th>
                <th>MATERIAL</th>
                <th>DESCRIPTION</th>
                <th>HSN</th>
                <th>QTY</th>
                <th>PART RATE</th>
                <th>TAXABLE AMOUNT</th>
                <th>TAX (%)</th>
                <th>TAX AMOUNT</th>
                <th>TOTAL AMOUNT</th>
                <th>DEP (%)</th>
                <th>DEP AMOUNT</th>
                <th>R&R CHARGES</th>
                <th>REPAIR CHARGES</th>
                <th>PAINTING CHARGES</th>
                <th>LABOUR CHARGES</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => {
                const { taxable, taxAmount, total, depAmount } =
                  calculateRow(row)
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>
                      <input
                        value={row.job}
                        onChange={e =>
                          handleChangeParts(i, 'job', e.target.value)
                        }
                      >
                        {/* <option value="Replace">Replace</option>
                            <option value="Repair">Repair</option> */}
                      </input>
                    </td>
                    <td>
                      <input
                        value={row.material}
                        onChange={e =>
                          handleChangeParts(i, 'material', e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        value={row.description}
                        onChange={e =>
                          handleChangeParts(i, 'description', e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        value={row.hsn}
                        onChange={e =>
                          handleChangeParts(i, 'hsn', e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type='number'
                        value={row.qty}
                        onChange={e =>
                          handleChangeParts(i, 'qty', e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type='number'
                        value={row.rate}
                        onChange={e =>
                          handleChangeParts(i, 'rate', e.target.value)
                        }
                      />
                    </td>
                    <td>₹{taxable.toFixed(1)}</td>
                    <td>
                      <input
                        type='number'
                        value={row.taxPercent}
                        onChange={e =>
                          handleChangeParts(i, 'taxPercent', e.target.value)
                        }
                      />
                    </td>
                    <td>₹{taxAmount.toFixed(1)}</td>
                    <td>₹{total.toFixed(1)}</td>
                    <td>
                      <input
                        type='number'
                        value={row.depPercent}
                        onChange={e =>
                          handleChangeParts(i, 'depPercent', e.target.value)
                        }
                      />
                    </td>
                    <td>₹{depAmount.toFixed(1)}</td>
                    <td>
                      <input
                        type='number'
                        value={row.rrCharges}
                        onChange={e =>
                          handleChangeParts(i, 'rrCharges', e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type='number'
                        value={row.repairCharges}
                        onChange={e =>
                          handleChangeParts(i, 'repairCharges', e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type='number'
                        value={row.paintingCharges}
                        onChange={e =>
                          handleChangeParts(
                            i,
                            'paintingCharges',
                            e.target.value
                          )
                        }
                      />
                    </td>
                    <td>
                      <input
                        type='number'
                        value={row.labourCharges}
                        onChange={e =>
                          handleChangeParts(i, 'labourCharges', e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <button
                        className='delete-btn'
                        onClick={() => deleteRow(i)}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                )
              })}
              <tr className='subtotal-row'>
                <td colSpan='7'>Subtotal</td>
                <td>₹{subtotal.taxable.toFixed(1)}</td>
                <td></td>
                <td>₹{subtotal.taxAmount.toFixed(1)}</td>
                <td>₹{subtotal.total.toFixed(1)}</td>
                <td></td>
                <td>₹{subtotal.depAmount.toFixed(1)}</td>
                <td colSpan='5'></td>
              </tr>
            </tbody>
          </table>

          <button className='add-parts' onClick={addRow}>
            + ADD Parts
          </button>

          {/* <div className='qc-section'>
            <h4>QC Recommendation</h4>
            <p>
              As reported in the claim form, the incident occurred while the
              insured vehicle was passing through waterlogged areas on the way.
              The vehicle stopped and was taken to the Hyundai dealer in Indore
              for repairs. After the repair work, while proceeding further, the
              vehicle stopped again. Discussions with ASM Hyundai Gwalior
              bodyshop associate revealed that this incident occurred at
              Agra-Mathura Highway on 28.08.2023 at 9:30 PM. Since the initial
              loss was reported at the Indore dealer, the insured filed the
              claim details based on the previous claim.
            </p>
          </div> */}

          {/* Action Buttons */}
          <div className='action-buttons'>
            <button className='approve-btn'>Approve Claim</button>
            <button className='reject-btn'>Reject Claim</button>
          </div>

          {/* Separate Finish Button */}
          {/* <div className="finish-btn-container">
            <button className="finish-btn">Finish ➜</button>
          </div> */}
          <div className='update-info-button-container'>
            <button
              className='update-info-submit-btn'
              onClick={saveFormDataToBackend}
              disabled={uploading}
            >
              {uploading ? 'Uploading...' : 'Finish →'}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

export default UpdateInfoClaimManual
